//TODO: Move all strings to /language/<code>/client-strings.json

/**
 * BatchGeoOptimalRouteToolbar inits the optimal route BatchGeoToolbar instance. This instance
 * has two states, the first allows the user to copy selected rows, and open the optimal route modal. The second
 * is for after the route has been calculated and allows the user to open the route in Google Maps to navigate,
 * or to reset the table/route.
 *
 * It takes no arguments or options. It simply returns the proper base instance.
 */
(function (window) {
  window.BatchGeoOptimalRouteToolbar = function () {
    //this feature is only for pro/lite users
    if (!BatchGeoStore.getState().App.pro) {
      return;
    }

    var directionsService = new google.maps.DirectionsService();
    var directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
    });

    var routeService = new window.BatchGeoCalculateRoute({
      directionsRenderer: directionsRenderer,
      directionsService: directionsService,
    });

    BatchGeoStore.addListener(
      function (state) {
        return state.BatchGeoOptimalRouteToolbar.currentRows;
      },
      function (nextState, prevState) {
        return !_.isEqual(nextState.toString(), prevState.toString());
      },
      function () {
        if (
          BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
            .matchNewSelectionToggled
        ) {
          BatchGeoStore.dispatch({
            type: "OPTIMAL_ROUTE_TOOLBAR_SET_SELECTION_GROUP",
            group: 1,
          });
        } else {
          BatchGeoStore.dispatch({
            type: "OPTIMAL_ROUTE_TOOLBAR_SET_SELECTION_GROUP",
            group: 0,
          });
        }
      },
    );

    function userDistance(p1, p2) {
      // Thanks Pythagoras... a^2 + b^2 = c^2
      var a = p1.lat - p2.lat;
      var b = p1.lng - p2.lng;
      return Math.sqrt(a * a + b * b);
    }

    /**
     * getClosestMarker grabs the selected markers from state and calculates which one
     * is closest to the user's current location. It then returns the closest point.
     *
     * @returns {Object} the closest selected marker location the user. It has an address,
     * and distance property. Address is the address of the marker, and distance is the distance
     * from user's current location.
     */
    var getClosestMarker = function () {
      var selectedRows =
        window.batchGeoTableMap.batchGeoTable.RowSelect.getSelectedRows();
      var userLocation = BatchGeoStore.getState().UserLocation;
      var userPosition = {
        lng: userLocation.longitude,
        lat: userLocation.latitude,
      };
      var markers = window.batchGeoGoogleMapsMarker.getMarkersObjArray();
      var selectedMarkers = selectedRows.map(function (selectedRow) {
        return markers[selectedRow.id];
      });
      var markerPositions = selectedMarkers.map(function (marker) {
        var coords = { position: { lat: marker.Lat, lng: marker.Lon } };
        coords.distance = userDistance(coords.position, userPosition);
        coords.address = marker.marker.addr;
        return coords;
      });

      var closestPointToMe = markerPositions.reduce(function (acc, val) {
        return acc.distance > val.distance ? val : acc;
      }, markerPositions[0]);
      return closestPointToMe;
    };

    /**
     * generateEmptyInputSuggestions returns the suggestions autocomplete provides when
     * the input is empty.
     *
     * @param {string} input the id of the input that we're generating suggestions for.
     *
     * @returns {Array} an array with a single suggestion object.
     */
    var generateEmptyInputSuggestions = function (input) {
      var getStartingLocation = function () {
        return $("#starting-location").val();
      };
      var isGeocodingEnabled = window.geocodingEnabled;
      var closestMarker = getClosestMarker();
      var response;
      if (input === "#starting-location") {
        response = isGeocodingEnabled
          ? {
              label: "Use Closest Map Location",
              desc: "Current location will be used if no starting location is provided",
            }
          : {
              label: "Use First Selected Waypoint",
              desc: "First selected waypoint will be used if no starting location is provided",
            };
        response.position = closestMarker.position;
        response.value = closestMarker.address;
      } else {
        var origin =
          BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.optimalRoute
            .origin;
        response = {
          label: "End at Starting Location",
          //make this a function so the value updates as the starting input changes
          value: function () {
            return getStartingLocation();
          },
          desc: "A map location will be used if no ending location is provided",
        };
        if (typeof origin !== "string") {
          response.position = origin;
        }
      }
      return [response];
    };

    /**
     * generateWaypointSuggestions returns an array of suggestion objects
     * from the selected markers for autocomplete.
     *
     * @returns {Array} an array of all the selected markers, formatted for autocomplete suggestions
     */
    var generateWaypointSuggestions = function () {
      var batchGeoTable = window.batchGeoTableMap.batchGeoTable;
      var selectedRows = batchGeoTable.RowSelect.getSelectedRows();
      var markers = window.batchGeoGoogleMapsMarker.getMarkersObjArray();

      return selectedRows.map(function (selectedRow) {
        var marker = markers[selectedRow.id];
        var location = marker.marker.addr;
        var position = marker?.position
          ? marker.position
          : new google.maps.LatLng({ lat: marker.Lat, lng: marker.Lon });
        return {
          value: location,
          desc: "from row number " + (selectedRow.id + 1),
          position: position,
          rowId: selectedRow.id,
        };
      });
    };
    /**
     * buildAutocomplete takes an input id and generates a dynamic autocomplete
     * suggestion menu for it. This utilizes BatchGeoAutocomplete, and google places
     * autocomplete service for custom places suggestions.
     *
     * @param {string} input the id of the input that we're generating suggestions for.
     */
    var buildAutocomplete = function (input) {
      var $searchBox = $(input);

      if ($searchBox.hasClass("ui-autocomplete-input")) {
        return;
      }
      var waypointList = generateWaypointSuggestions();
      var autocomplete = new BatchGeoAutocomplete({
        container: $searchBox,
        source: function (request, response) {
          var service = new google.maps.places.AutocompleteService();
          var waypointSuggestions = $.ui.autocomplete.filter(
            waypointList,
            request.term,
          );

          if (request.term) {
            //if the input is not empty show googles suggestion with waypoint suggestions
            service.getPlacePredictions(
              { input: request.term },
              function (predictions) {
                var googleSuggestions = [];
                if (predictions) {
                  predictions.forEach(function (prediction, id) {
                    //only include the first two suggestions
                    if (id < 2) {
                      googleSuggestions.push(prediction.description);
                    }
                  });
                }
                response(waypointSuggestions.concat(googleSuggestions));
              },
            );
          } else {
            response(generateEmptyInputSuggestions(input));
          }
        },
        select: function (event, ui) {
          BatchGeoStore.dispatch({
            type:
              input === "#starting-location"
                ? "OPTIMAL_ROUTE_TOOLBAR_SET_ORIGIN"
                : "OPTIMAL_ROUTE_TOOLBAR_SET_DESTINATION",
            position: ui.item.position ? ui.item.position : ui.item.value,
          });
          if (!BatchGeoDevices.is("mobile")) {
            //auto focus on mobile forces colorbox to resize and make sizes inconsistent
            $("#ending-location").focus();
          }
        },
        minLength: 0,
        position: {
          my: "left top",
          at: "left bottom",
          collision: "flip",
        },
        open: function () {
          $("ul.ui-autocomplete").css("width", $searchBox.outerWidth());
        },
      });

      autocomplete
        .getJqueryInstance()
        .focus(function () {
          //this opens the autocomplete menu on focus, that way we can show suggestions with an empty input
          $(this).data("uiAutocomplete").search($(this).val());
        })
        .data("uiAutocomplete")._renderItem = function (ul, item) {
        //this overrides jQuery's default formatting for each suggestions.
        var suggestionClass = "suggestion ";
        if (item.desc) {
          suggestionClass += "waypointSuggestion";
        }
        return $("<li />", {
          class: "ui-menu-item " + suggestionClass,
          html: $("<a />", {
            class: "ui-corner-all",
            html: [
              $("<p />", {
                html: item.label,
              }),
              $("<p />", {
                html: item.desc,
                class: "autocomplete-description",
              }),
            ],
          }),
        }).appendTo(ul);
      };
    };

    /**
     * mapDirections is called when the user submits the form in
     * the modal. We take the origin and destination and call the
     * routeservice's buildValidRoute method.
     */
    function mapDirections() {
      var map = window.batchGeoGoogleMapsManager.getMap();
      directionsRenderer.setMap(map);

      routeService.buildValidRoute();

      $("#starting-location").val("");
      $("#ending-location").val("");
    }

    var areDirectionsSet = function () {
      return !BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
        .routeCalculated;
    };

    var composeWaypoints = function () {
      var route =
        BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.optimalRoute;

      // remove legs where start_address === end_address
      const validLegs = route.legs.filter(
        (leg) => leg.start_address !== leg.end_address,
      );

      // waypoints is all legs start address plus the last legs end address
      const waypoints = validLegs.reduce(
        (accumulator, current, index, source) => {
          accumulator.push(current.start_address);

          const isCurrentLastIndex = index === source.length - 1;
          if (isCurrentLastIndex) {
            accumulator.push(current.end_address);
          }

          return accumulator;
        },
        [],
      );

      return waypoints;
    };

    var calculateWaypointLimit = function (waypoints = undefined) {
      if (!waypoints) waypoints = composeWaypoints();
      return waypoints[0] === waypoints[waypoints.length - 1] ? 11 : 10;
    };

    /**
     * buildRouteUrl takes the optimal route from state and URI encodes each
     * location to build a URL in order to link to google maps
     *
     * @returns {string} URL to google maps navigating the optimal route
     */
    var buildRouteUrl = function (waypoints = undefined) {
      var baseUrl = "https://www.google.com/maps/dir/";

      if (!waypoints) waypoints = composeWaypoints();

      // encode waypoints
      const encodedWaypoints = waypoints.map(
        (item) => encodeURIComponent(item) + "/",
      );

      return baseUrl + encodedWaypoints.join("");
    };

    const isButtonActive = () => {
      const bgort = BatchGeoStore.getState().BatchGeoOptimalRouteToolbar;
      if (
        (!bgort.matchNewSelectionToggled &&
          bgort.selectedRowGroupA.length > 1) ||
        (bgort.matchNewSelectionToggled &&
          bgort.selectedRowGroupA.length > 0 &&
          bgort.selectedRowGroupB.length > 0)
      ) {
        return true;
      } else {
        return false;
      }
    };

    function switchHands() {
      BatchGeoStore.dispatch({
        type: "DRAWING_MANAGER_SET_MODE",
        mode: "hand",
      });
    }

    const calculate = () => {
      const bgort = BatchGeoStore.getState().BatchGeoOptimalRouteToolbar;
      const groupBCount = bgort.selectedRowGroupB.length;
      const groupACount = bgort.selectedRowGroupA.length;

      if (
        (!groupBCount < 1 && !groupACount < 1 && bgort.groupDistanceEngaged) ||
        (bgort.distanceChannel == 0 && groupACount > 1)
      ) {
        let groupDistance = new BatchGeoGroupDistance();
        window.batchGeoGroupDistance = groupDistance;
        // need to limit the actual number of markers
        groupDistance.fixRows();

        // initialize function checks prevRows, and if empty, copies the current rows over to prevRows
        // to build out the costMatrix when the rows/columns
        groupDistance.initialize();

        let newMatrix = groupDistance.createEmptyMatrix();

        groupDistance.setMatrix(newMatrix);
        groupDistance.fillDistanceMatrix();

        switchHands();
        let results = null;

        if (bgort.distanceCalculationOption == 1) {
          // distanceCalculationOptions == 1 -> closest neighbor
          // closestNeighbor
          if (bgort.distanceChannel == 0) {
            // distanceChannel == 0 -> single group
            // handles single group instance of closest neighbor
            results = groupDistance.singleGroupDistance(0);
          } else {
            groupDistance.closestNeighbor();
          }
        } else if (bgort.distanceCalculationOption == 2) {
          // distanceCalculationOptions == 2 -> closest unique neighbor
          const munkres = new window.BatchGeoMunkres();
          let distanceMat = groupDistance.getMatrix();

          if (bgort.distanceChannel == 0) {
            // distanceChannel == 0 -> single group
            // blow up the diagonal such that 0 distance locations are not considered.
            for (let x = 0; x < distanceMat.length; x++) {
              distanceMat[x][x] = 99999;
            }
          }

          // cant seem to drop context
          let newContextMatrix = [];
          for (let row = 0; row < distanceMat.length; row++) {
            newContextMatrix[row] = [];
            for (let col = 0; col < distanceMat[0].length; col++) {
              newContextMatrix[row][col] = distanceMat[row][col];
            }
          }

          let path = munkres.run(newContextMatrix);
          groupDistance.setPath(path);
          groupDistance.closestUniqueNeighbor();
        } else {
          //least distance
          if (bgort.distanceChannel == 0) {
            // handles single group instance of least distance
            results = groupDistance.singleGroupDistance(1);
          } else {
            results = groupDistance.leastDistance();
          }
        }

        if (results !== -1) {
          groupDistance.createHeatMap();
          groupDistance.buildPolylines();
          window.batchGeoGoogleMapsMarker.MarkerLegend.updatePolylineColors();
        }

        groupDistance.updateState();
      }
    };

    function resetMapDataAndView() {
      let rows = window.batchGeoTableMap.batchGeoTable.data.rows;
      let columns = window.batchGeoTableMap.batchGeoTable.data.columns;

      let distanceColumnIndex = columns.indexOf("Distance Between Points");
      let destinationColumnIndex = columns.indexOf("Destination");

      let offset = 0;
      if (distanceColumnIndex > -1 && destinationColumnIndex > -1) {
        offset = 2;
      } else if (
        !(distanceColumnIndex > -1 && destinationColumnIndex > -1) &&
        (distanceColumnIndex > -1 || destinationColumnIndex > -1)
      ) {
        offset = 1;
      }
      //need to know how many columns before adding distance/destination columns

      let numColumns = columns.length;

      for (
        let x = 0;
        x < window.batchGeoGoogleMapsMarker.options.markersData.dataRS.length;
        x++
      ) {
        //this can be fine tuned to find the distance/destination columns,
        //then use those values to remove specific indecies
        //(we assume distance/destination as the final columns due to when they are added to the data table)
        if (
          window.batchGeoGoogleMapsMarker.options.markersData.dataRS[x].length >
          numColumns - offset
        ) {
          while (
            window.batchGeoGoogleMapsMarker.options.markersData.dataRS[x]
              .length >
            numColumns - offset
          ) {
            window.batchGeoGoogleMapsMarker.options.markersData.dataRS[x].pop(); // pops distance/destination
          }
        }
      }

      if (columns[columns.length - 1] == "Destination") {
        //this will catch if the date/destination columns are in place
        rows.forEach((row) => {
          while (
            row.data.length >
            window.batchGeoTableMap.batchGeoTable.data.columns.length - 2
          ) {
            row.data.pop(); //remove old points
          }
        });
      }

      window.batchGeoTableMap.optimalDistanceColumnGenerator.removeColumn();
      window.batchGeoTableMap.destinationColumnGenerator.removeColumn();

      if (
        window.batchGeoGoogleMapsMarker.MarkerLegend.isActive() &&
        window.per.legend_columns &&
        window.per.legend_columns.length
      ) {
        window.batchGeoGoogleMapsMarker.MarkerLegend.updateColumnList();
        window.batchGeoGoogleMapsMarker.MarkerLegend.filterColumns(true);
      }

      window.batchGeoTableMap.batchGeoTable.updateRowDisplay(rows, () => {});
      window.batchGeoTableMap.batchGeoTable.setDisplayData(rows);

      if (
        window.batchGeoGoogleMapsMarker.MarkerLegend.isActive() &&
        window.per.legend_columns &&
        window.per.legend_columns.length
      ) {
        window.batchGeoGoogleMapsMarker.MarkerLegend.selectPreviousColumn(true);
      }
      //remove the filters that may be in the heat arrays

      window.batchGeoGoogleMapsMarker.MarkerLegend.clearFilters();
    }

    $(document).on("cbox_complete", function () {
      //wait until the modal open animation is complete before focusing on the first input.
      //That way the autocomplete menu doesn't open before the modal
      if (!BatchGeoDevices.is("mobile")) {
        //auto focus on mobile forces colorbox to resize and make sizes inconsistent
        setTimeout(function () {
          $("#starting-location").focus();
        }, 300);
      }
    });

    $(document).on("cbox_closed", function () {
      BatchGeoStore.dispatch({
        type: "OPTIMAL_ROUTE_MODAL_VISIBILITY",
        isVisible: false,
      });
    });

    //this is the html we inject into the optimal route modal when it opens.
    var formHtml = $("<div />", {
      id: "optimal-route-form-container",
      html: $("<form />", {
        class: "optimal-route-form input_desc",
        html: [
          $("<div />", {
            class: "form_row",
            html: [
              $("<label />", {
                text: "Starting Location",
                for: "starting-location",
              }),
              $("<div />", {
                class: "search_field_wrap",
                html: [
                  $("<div />", {
                    class: "search_icon",
                  }),
                  $("<input />", {
                    id: "starting-location",
                  }),
                ],
              }),
            ],
          }),
          $("<div />", {
            class: "form_row",
            html: [
              $("<label />", {
                text: "Ending Location",
                for: "ending-location",
              }),
              $("<div />", {
                class: "search_field_wrap",
                html: [
                  $("<div />", {
                    class: "search_icon",
                  }),
                  $("<input />", {
                    id: "ending-location",
                    placeholder: "Leave blank if the same as starting location",
                  }),
                ],
              }),
            ],
          }),
          $("<button />", {
            type: "button",
            text: "Map Optimal Route",
            class: "button green",
            click: mapDirections,
          }),
        ],
      }),
    });

    var distanceCalculations = {
      0: "Least Distance",
      1: "Closest Neighbor",
      2: "Closest Unique Neighbor",
    };

    var batchGeoToolbar = new BatchGeoToolbar({
      class: "optimal-route-toolbar",
      container: "#mapWrap",
      buttons: function () {
        let buttonState = BatchGeoStore.getState().BatchGeoOptimalRouteToolbar;
        if (buttonState.groupDistanceEngaged && buttonState.distanceMode == 3) {
          return [
            {
              "Back to Calculation Options": {
                icon: "undock",
                label: "Back",
                class: "button-reset-route",
                visibility: [true],
                action: function () {
                  BatchGeoStore.dispatch([
                    {
                      type: "OPTIMAL_ROUTE_GROUP_DISTANCE_MODE",
                      distanceMode: 1,
                    },
                  ]);
                  batchGeoToolbar.render();
                },
              },
            },
            {
              "Hold shift while selecting": {
                label: function () {
                  return "Select additional marker(s)";
                },
                class: (function () {
                  return "groupSelectionCount";
                })(),
                visibility: [
                  BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                    .distanceChannel == 0 &&
                  BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                    .currentRows.length < 2
                    ? true
                    : false,
                ],
                action: "",
              },
            },
            {
              "selected groups": {
                label: function () {
                  var currRowCount =
                    BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                      .selectedRowGroupA.length;
                  var prevRowCount =
                    BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                      .selectedRowGroupB.length;
                  if (currRowCount > 0 && prevRowCount > 0)
                    return "(2 / 2) Groups Selected";
                  else if (currRowCount > 0 || prevRowCount > 0)
                    return "(1 / 2) Groups Selected";
                  else return "(0 / 2) Groups Selected";
                },
                class: (function () {
                  return "groupSelectionCount";
                })(),
                visibility: [
                  BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                    .distanceChannel == 1
                    ? true
                    : false,
                ],
                action: "",
              },
            },
            {
              "Group Distance": {
                icon: "direction",
                label: function () {
                  var value =
                    BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                      .groupDistanceEngaged;
                  if (value) {
                    return (
                      "Calculate " +
                      distanceCalculations[
                        BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                          .distanceCalculationOption
                      ]
                    );
                  }
                  return "Group Distance";
                },
                class: (function () {
                  const optimalRouteToolbar =
                    BatchGeoStore.getState().BatchGeoOptimalRouteToolbar;
                  const groupACount =
                    optimalRouteToolbar.matchNewSelectionToggled
                      ? optimalRouteToolbar.selectedRowGroupA.length
                      : optimalRouteToolbar.previousRows.length;
                  const groupBCount =
                    optimalRouteToolbar.matchNewSelectionToggled
                      ? optimalRouteToolbar.selectedRowGroupB.length
                      : optimalRouteToolbar.currentRows.length;

                  if (
                    (groupBCount < 2 &&
                      optimalRouteToolbar.distanceChannel !== 1) ||
                    ((groupBCount < 1 || groupACount < 1) &&
                      optimalRouteToolbar.distanceChannel != 0)
                  ) {
                    return "button-optimal-route grey-out";
                  } else {
                    return "button-optimal-route";
                  }
                })(),
                visibility: [areDirectionsSet()],
                action: function () {
                  const optimalRouteToolbar =
                    BatchGeoStore.getState().BatchGeoOptimalRouteToolbar;

                  if (!optimalRouteToolbar.groupDistanceEngaged) {
                    BatchGeoStore.dispatch([
                      {
                        type: "OPTIMAL_ROUTE_GROUP_DISTANCE_ENGAGED",
                        isEngaged: true,
                      },
                      {
                        type: "OPTIMAL_ROUTE_GROUP_DISTANCE_MODE",
                        distanceMode: 1,
                      },
                      {
                        type: "DRAWNING_MANAGER_SET_MODE",
                        mode: "hand",
                      },
                    ]);
                  } else {
                    calculate();
                  }
                },
              },
            },
          ];
        } else if (
          buttonState.groupDistanceEngaged &&
          buttonState.distanceMode == 1
        ) {
          return [
            {
              Reset: {
                icon: "undock",
                label: "Exit",
                class: "button-reset-route",
                visibility: [true],
                action: function () {
                  BatchGeoStore.dispatch([
                    {
                      type: "OPTIMAL_ROUTE_TOOLBAR_VISIBILITY",
                      isVisible: false,
                    },
                    { type: "ROW_SELECT_DESELECTALL" },
                    {
                      type: "OPTIMAL_ROUTE_GROUP_DISTANCE_ENGAGED",
                      isEngaged: false,
                    },
                    {
                      type: "OPTIMAL_ROUTE_GROUP_CURRENT_ROW_UPDATE",
                      currentRows: [],
                    },
                    {
                      type: "OPTIMAL_ROUTE_GROUP_PREVIOUS_ROW_UPDATE",
                      previousRows: [],
                    },
                    {
                      type: "OPTIMAL_ROUTE_CLEAR_POLYLINES",
                    },
                    {
                      type: "OPTIMAL_ROUTE_GROUP_DISTANCE_MODE",
                      distanceMode: 0,
                    },
                    {
                      type: "DRAWING_MANAGER_SET_MODE",
                      mode: "hand",
                    },
                    {
                      type: "OPTIMAL_ROUTE_TOOLBAR_CLEAR_SELECTIONS",
                    },
                  ]);

                  batchGeoToolbar.render();
                },
              },
            },
            {
              "Hold shift while selecting": {
                label: function () {
                  return "Select additional marker(s)";
                },
                class: (function () {
                  return "groupSelectionCount";
                })(),
                visibility: [
                  BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                    .distanceChannel == 0 &&
                  BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                    .currentRows.length < 2
                    ? true
                    : false,
                ],
                action: "",
              },
            },

            {
              "selected groups": {
                label: function () {
                  var currRowCount =
                    BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                      .selectedRowGroupA.length;
                  var prevRowCount =
                    BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                      .selectedRowGroupB.length;
                  if (currRowCount > 0 && prevRowCount > 0)
                    return "(2 / 2) Groups Selected";
                  else if (currRowCount > 0 || prevRowCount > 0)
                    return "(1 / 2) Groups Selected";
                  else return "(0 / 2) Groups Selected";
                },
                class: (function () {
                  return "groupSelectionCount";
                })(),
                visibility: [
                  BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                    .distanceChannel == 1
                    ? true
                    : false,
                ],
                action: "",
              },
            },
            {
              class: "routing-container",
              inlineGroup: true,
              style: "routing-section",
              headerTitle: "",
              headerStyle: "routing-header",
              spacerStyle: "routing-spacers",
              buttonStyle: "routing-button",
              buttons: [
                {
                  "Least Total Distance": {
                    icon: "ruler",
                    label: "Calculate Least Distance",
                    class: isButtonActive()
                      ? "button-optimal-route"
                      : "button-optimal-route grey-out",
                    visibility: [
                      areDirectionsSet(),
                      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                        .polylineData.length == 0
                        ? true
                        : false,
                    ],
                    action: function () {
                      if (isButtonActive()) {
                        const groupDistanceState =
                          BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                            .groupDistanceEngaged;
                        if (!groupDistanceState) {
                          BatchGeoStore.dispatch({
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_ENGAGED",
                            isEngaged: true,
                          });
                        }

                        BatchGeoStore.dispatch([
                          {
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_CALCULATION_OPTION",
                            distanceCalculationOption: 0,
                          },
                          {
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_MODE",
                            distanceMode: 3,
                          },
                        ]);

                        calculate();
                      }
                    },
                  },
                },
                {
                  "Closest Neighbor: (duplicates destination possible)": {
                    icon: "ruler",
                    label: "Calculate Closest Neighbor",
                    class: isButtonActive()
                      ? "button-optimal-route"
                      : "button-optimal-route grey-out",
                    visibility: [
                      areDirectionsSet(),
                      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                        .polylineData.length == 0
                        ? true
                        : false,
                    ],
                    action: function () {
                      if (isButtonActive()) {
                        var groupDistanceState =
                          BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                            .groupDistanceEngaged;
                        if (!groupDistanceState) {
                          BatchGeoStore.dispatch({
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_ENGAGED",
                            isEngaged: true,
                          });
                        }
                        BatchGeoStore.dispatch([
                          {
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_CALCULATION_OPTION",
                            distanceCalculationOption: 1,
                          },
                          {
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_MODE",
                            distanceMode: 3,
                          },
                        ]);

                        calculate();
                      }
                    },
                  },
                },
                {
                  "Closest Unique Neighbor": {
                    icon: "ruler",
                    label: "Calculate Closest Unique Neighbor",
                    class: isButtonActive()
                      ? "button-optimal-route"
                      : "button-optimal-route grey-out",
                    visibility: [
                      areDirectionsSet(),
                      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                        .polylineData.length == 0
                        ? true
                        : false,
                    ],
                    action: function () {
                      if (isButtonActive()) {
                        var groupDistanceState =
                          BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                            .groupDistanceEngaged;
                        if (!groupDistanceState) {
                          BatchGeoStore.dispatch({
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_ENGAGED",
                            isEngaged: true,
                          });
                        }
                        BatchGeoStore.dispatch([
                          {
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_CALCULATION_OPTION",
                            distanceCalculationOption: 2,
                          },
                          {
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_MODE",
                            distanceMode: 3,
                          },
                        ]);

                        calculate();
                      }
                    },
                  },
                },
              ],
            },
          ];
        } else {
          return [
            {
              "Copy Rows": {
                icon: "copy",
                label: "Copy Rows",
                class: "button-copy-rows",
                visibility: [areDirectionsSet()],
                action: function () {
                  //give the user feedback that the rows were copied
                  $(".button-copy-rows").addClass("copied");
                  setTimeout(function () {
                    $(".button-copy-rows").removeClass("copied");
                  }, 500);

                  var batchGeoCopyMachine = window.BatchGeoCopyMachine();
                  var batchGeoTable = window.batchGeoTableMap.batchGeoTable;
                  batchGeoCopyMachine.copyContents(function () {
                    // Save the content here so when we destroy the component
                    // the content still lives

                    var content = window.TableExporter({
                      columns: batchGeoTable.data.columns,
                      rows: batchGeoTable.RowSelect.getSelectedRows(),
                      sortAgainst: batchGeoTable.getDisplayData(),
                    });

                    // Destroy the content textarea so they don't keep stacking
                    // up in the DOM each time you right click copy
                    batchGeoCopyMachine.destroy();
                    return content;
                  }, true);
                },
              },
            },
            {
              class: "routing-container",
              inlineGroup: true,
              style: "routing-section",
              headerTitle: "Routing:",
              headerStyle: "routing-header",
              spacerStyle: "routing-spacers",
              buttonStyle: "routing-button",
              buttons: [
                {
                  "Optimal Route": {
                    icon: "direction",
                    label: "Optimal Route",
                    class: "button-optimal-route",
                    visibility: [areDirectionsSet()],
                    action: function () {
                      BatchGeoStore.dispatch({
                        type: "OPTIMAL_ROUTE_MODAL_VISIBILITY",
                        isVisible: true,
                      });
                    },
                  },
                },
                {
                  "Match Closest Pairs": {
                    icon: "direction",
                    label: function () {
                      var value =
                        BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                          .groupDistanceEngaged;
                      if (value) {
                        return "Calculate Distance to Selected Groups";
                      }
                      return "Match Closest Pairs";
                    },
                    class: (function () {
                      const optimalRouteToolbar =
                        BatchGeoStore.getState().BatchGeoOptimalRouteToolbar;
                      const groupACount =
                        optimalRouteToolbar.matchNewSelectionToggled
                          ? optimalRouteToolbar.selectedRowGroupA.length
                          : optimalRouteToolbar.previousRows.length;
                      const groupBCount =
                        optimalRouteToolbar.matchNewSelectionToggled
                          ? optimalRouteToolbar.selectedRowGroupB.length
                          : optimalRouteToolbar.currentRows.length;

                      if (
                        (groupBCount < 1 || groupACount < 1) &&
                        optimalRouteToolbar.groupDistanceEngaged
                      ) {
                        return "button-optimal-route grey-out";
                      } else {
                        return "button-optimal-route";
                      }
                    })(),
                    visibility: [
                      areDirectionsSet(),
                      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                        .polylineData.length == 0
                        ? true
                        : false,
                    ],
                    action: function () {
                      var groupDistanceState =
                        BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                          .groupDistanceEngaged;

                      BatchGeoStore.dispatch({
                        type: "OPTIMAL_ROUTE_GROUP_DISTANCE_CHANNEL",
                        distanceChannel: 0,
                      });

                      if (!groupDistanceState) {
                        BatchGeoStore.dispatch({
                          type: "OPTIMAL_ROUTE_GROUP_DISTANCE_ENGAGED",
                          isEngaged: true,
                        });
                        BatchGeoStore.dispatch({
                          type: "OPTIMAL_ROUTE_GROUP_DISTANCE_MODE",
                          distanceMode: 1,
                        });
                      }
                    },
                  },
                },
                {
                  "Match New Selection": {
                    icon: "direction",
                    label: function () {
                      var value =
                        BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                          .groupDistanceEngaged;
                      if (value) {
                        return "Calculate Distance to Selected Groups";
                      }
                      return "Match New Selection";
                    },
                    class: (function () {
                      const optimalRouteToolbar =
                        BatchGeoStore.getState().BatchGeoOptimalRouteToolbar;
                      const groupACount =
                        optimalRouteToolbar.matchNewSelectionToggled
                          ? optimalRouteToolbar.selectedRowGroupA.length
                          : optimalRouteToolbar.previousRows.length;
                      const groupBCount =
                        optimalRouteToolbar.matchNewSelectionToggled
                          ? optimalRouteToolbar.selectedRowGroupB.length
                          : optimalRouteToolbar.currentRows.length;

                      if (
                        (groupBCount < 1 || groupACount < 1) &&
                        optimalRouteToolbar.groupDistanceEngaged
                      ) {
                        return "button-optimal-route grey-out";
                      } else {
                        return "button-optimal-route";
                      }
                    })(),
                    visibility: [
                      areDirectionsSet(),
                      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                        .polylineData.length == 0
                        ? true
                        : false,
                    ],
                    action: function () {
                      var groupDistanceState =
                        BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                          .groupDistanceEngaged;
                      switchHands();

                      BatchGeoStore.dispatch([
                        {
                          type: "DRAWING_MANAGER_SET_MODE",
                          mode: "rectangle",
                        },
                        {
                          type: "OPTIMAL_ROUTE_GROUP_DISTANCE_CHANNEL",
                          distanceChannel: 1,
                        },
                        {
                          type: "OPTIMAL_ROUTE_TOOLBAR_TOGGLE_MATCH_NEW_SELECTION",
                        },
                      ]);

                      if (!groupDistanceState) {
                        BatchGeoStore.dispatch({
                          type: "OPTIMAL_ROUTE_GROUP_DISTANCE_ENGAGED",
                          isEngaged: true,
                        });
                        BatchGeoStore.dispatch([
                          {
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_MODE",
                            distanceMode: 1,
                          },
                          {
                            type: "OPTIMAL_ROUTE_GROUP_DISTANCE_CHANNEL",
                            distanceChannel: 1,
                          },
                        ]);
                      }
                    },
                  },
                },
                {
                  Reset: {
                    icon: "refresh",
                    label: "Clear Distance Calculation",
                    class: "button-reset-route",
                    visibility: [
                      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                        .polylineData.length > 0
                        ? true
                        : false /*visiblePolylines()*/,
                    ], // if there are any polylines, show this to clear
                    action: window.ClearDistanceCalculations,
                  },
                },
                {
                  Reset: {
                    icon: "refresh",
                    label: "Reset Route",
                    class: "button-reset-route",
                    visibility: [!areDirectionsSet()],
                    action: function () {
                      BatchGeoStore.dispatch([
                        {
                          type: "OPTIMAL_ROUTE_TOOLBAR_VISIBILITY",
                          isVisible: false,
                        },
                        { type: "ROW_SELECT_DESELECTALL" },
                        {
                          type: "DRAWING_MANAGER_SET_MODE",
                          mode: "hand",
                        },
                      ]);
                    },
                  },
                },
                {
                  Navigate: {
                    icon: "direction",
                    label: "Navigate",
                    class: "button-navigate",
                    visibility: [!areDirectionsSet()],
                    action: function () {
                      var waypoints = composeWaypoints();
                      if (
                        waypoints.length > calculateWaypointLimit(waypoints)
                      ) {
                        BatchGeo.customDialog(
                          "Only the first 10 locations will work using Google Maps Navigation, for full directions use print button.",
                          {
                            showConfirmBtn: true,
                            showDismissBtn: true,
                            confirmFn: function () {
                              window.batchGeoPrinter.dialog();
                            },
                            dismissFn: function () {
                              var routeUrl = buildRouteUrl(waypoints);
                              window.open(routeUrl);
                            },
                            confirmText: "Print",
                            dismissText: "Continue to Google Maps",
                          },
                        );
                      } else {
                        var routeUrl = buildRouteUrl(waypoints);
                        window.open(routeUrl);
                      }
                    },
                  },
                },
              ],
            },
          ];
        }
      },
    });

    window.ClearDistanceCalculations = function () {
      resetMapDataAndView();
      window.batchGeoTableMap?.clearListForDispatch();

      BatchGeoStore.dispatch([
        {
          type: "OPTIMAL_ROUTE_TOOLBAR_VISIBILITY",
          isVisible: false,
        },
        { type: "ROW_SELECT_DESELECTALL" },
        {
          type: "OPTIMAL_ROUTE_GROUP_DISTANCE_ENGAGED",
          isEngaged: false,
        },
        {
          type: "OPTIMAL_ROUTE_GROUP_CURRENT_ROW_UPDATE",
          currentRows: [],
        },
        {
          type: "OPTIMAL_ROUTE_GROUP_PREVIOUS_ROW_UPDATE",
          previousRows: [],
        },
        {
          type: "OPTIMAL_ROUTE_CLEAR_POLYLINES",
        },
        {
          type: "OPTIMAL_ROUTE_GROUP_DISTANCE_MODE",
          distanceMode: 0,
        },
        {
          type: "OPTIMAL_ROUTE_GROUP_DISTANCE_CHANNEL",
          distanceChannel: -1,
        },
        {
          type: "DRAWING_MANAGER_SET_MODE",
          mode: "hand",
        },
        {
          type: "OPTIMAL_ROUTE_TOOLBAR_CLEAR_SELECTIONS",
        },
      ]);
      batchGeoToolbar.render();
      window.batchGeoTableMap.batchGeoTable.render();
    };

    BatchGeoStore.addListener(
      "BatchGeoOptimalRouteToolbar",
      "toolbarVisible",
      function (toolbarState) {
        if (toolbarState.toolbarVisible) {
          batchGeoToolbar.show();
        } else {
          batchGeoToolbar.hide();
          routeService.resetRoute();
        }
      },
    );

    BatchGeoStore.addListener(
      "BatchGeoOptimalRouteToolbar",
      "modalVisible",
      function (toolbarState) {
        if (toolbarState.modalVisible) {
          BatchGeoStore.dispatch({
            type: "TABLE_MAP_SELECTABLE",
            isTableSelectable: false,
          });

          var selectedRows = BatchGeoStore.getState().RowSelect.selection;
          var isLite = BatchGeoStore.getState().App.isLite;

          const waypointLimit = isLite ? 10 : 25;

          if (selectedRows.length > waypointLimit) {
            if (isLite) {
              var upgrade = window.location.origin + "/admin/subscription/";
              BatchGeo.customAlert(
                'The number of selected waypoints must be less than 10 to calculate optimal route. <a href="' +
                  upgrade +
                  '">Upgrade</a> to Pro for up to 25 waypoints.',
              );
            } else {
              BatchGeo.customAlert(
                "The number of selected waypoints must be less than 25 to calculate optimal route.",
              );
            }
            //reset toolbar state because we did not find optimal route
            toolbarState.modalVisible = false;
          } else {
            var width = BatchGeoDevices.is("mobile") ? "100%" : "800px";
            $.colorbox({
              inline: true,
              width: width,
              href: formHtml,
              onComplete: function () {
                buildAutocomplete("#starting-location");
                buildAutocomplete("#ending-location");
                //reset toolbar state in case the user backs out of the modal without finding an optimal route
                toolbarState.modalVisible = false;
              },
            });
          }
        } else {
          console.log("Table map selectable true");
          BatchGeoStore.dispatch({
            type: "TABLE_MAP_SELECTABLE",
            isTableSelectable: true,
          });
        }
      },
    );

    BatchGeoStore.addListener(
      "BatchGeoOptimalRouteToolbar",
      "previousRows",
      function (toolbarState) {
        if (toolbarState.groupDistanceEngaged) {
          BatchGeoStore.dispatch({
            type: "OPTIMAL_ROUTE_TOOLBAR_VISIBILITY",
            isVisible: true,
          });
          batchGeoToolbar.render();
        }
      },
    );

    BatchGeoStore.addListener(
      "BatchGeoOptimalRouteToolbar",
      "uncleanedRows",
      function (toolbarState) {
        //find all ids that are not currently inside current/previous....
        let currentMarkerIds = toolbarState.currentRows;
        let previousMarkerIds = toolbarState.previousRows;
        let uncleanedMarkerIds = toolbarState.uncleanedRows;
        let trueCleanup = [];

        for (let x = 0; x < uncleanedMarkerIds.length; x++) {
          if (
            currentMarkerIds.indexOf(uncleanedMarkerIds[x]) == -1 ||
            previousMarkerIds.indexOf(uncleanedMarkerIds[x] == -1)
          )
            trueCleanup.push(uncleanedMarkerIds[x]);
        }

        trueCleanup.forEach((row) => {
          window.batchGeoGoogleMapsMarker.MarkerResizer.zoomOut(
            window.batchGeoGoogleMapsMarker.getMarker(row),
          );
        });
      },
    );

    BatchGeoStore.addListener(
      "BatchGeoOptimalRouteToolbar",
      "currentRows",
      function (toolbarState) {
        BatchGeoStore.dispatch({
          type: "OPTIMAL_ROUTE_TOOLBAR_VISIBILITY",
          isVisible: toolbarState.currentRows.length > 1 ? true : false,
        });
        batchGeoToolbar.render();
      },
    );

    BatchGeoStore.addListener(
      "BatchGeoOptimalRouteToolbar",
      "distanceChannel",
      function (toolbarState) {
        if (
          toolbarState.distanceChannel !== 0 &&
          toolbarState.distanceChannel !== -1
        ) {
          let previousRows =
            BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
              .selectedRowGroupA;
          let currentRows =
            BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
              .selectedRowGroupB;
          // 2 groups selected before the distanceChannel was established.
          if (previousRows.length > 0 && currentRows.length > 0) {
            //set previous rows to pending
            previousRows.forEach((row) => {
              window.batchGeoGoogleMapsMarker.MarkerResizer.pend(
                window.batchGeoGoogleMapsMarker.getMarker(row),
              );
            });
            //set current rows to active
            currentRows.forEach((row) => {
              window.batchGeoGoogleMapsMarker.MarkerResizer.zoomIn(
                window.batchGeoGoogleMapsMarker.getMarker(row),
              );
            });
          } else {
            let rows = BatchGeoStore.getState().RowSelect.selection;
            rows.forEach((row) => {
              window.batchGeoGoogleMapsMarker.MarkerResizer.pend(
                window.batchGeoGoogleMapsMarker.getMarker(row),
              );
            });
          }
        }
      },
    );

    BatchGeoStore.addListener(
      "BatchGeoOptimalRouteToolbar",
      "distanceMode",
      function (toolbarState) {
        if (toolbarState.distanceMode !== 0) {
          BatchGeoStore.dispatch({
            type: "OPTIMAL_ROUTE_TOOLBAR_VISIBILITY",
            isVisible: true,
          });
        }
        batchGeoToolbar.render();
      },
    );

    BatchGeoStore.addListener(
      "BatchGeoOptimalRouteToolbar",
      "groupDistanceEngaged",
      function (toolbarState) {
        batchGeoToolbar.render();
        BatchGeoStore.dispatch({
          type: "OPTIMAL_ROUTE_TOOLBAR_VISIBILITY",
          isVisible: toolbarState.groupDistanceEngaged ? true : false,
        });
      },
    );

    BatchGeoStore.addListener(
      "BatchGeoOptimalRouteToolbar",
      "routeCalculated",
      function () {
        batchGeoToolbar.render();
      },
    );

    //toggle toolbar visibility based on which rows are selected
    BatchGeoStore.addListener(
      function (state) {
        return state.RowSelect.selection;
      },
      function (nextSelection, prevSelection) {
        if (prevSelection.length <= 1) {
          return nextSelection.length > 1;
        } else {
          return nextSelection.length <= 1;
        }
      },
      function (markerIds, prevMarkerIds) {
        if (markerIds.length > 0) {
          //show optimal route toolbar
          BatchGeoStore.dispatch({
            type: "OPTIMAL_ROUTE_TOOLBAR_VISIBILITY",
            isVisible: true,
          });
        }
        if (prevMarkerIds.length > 0) {
          BatchGeoStore.dispatch({
            type: "OPTIMAL_ROUTE_TOOLBAR_VISIBILITY",
            isVisible: true,
          });
        }
      },
    );

    $(window).on("batchgeo.bgsize", function () {
      var $legWrap = $("#legWrap");
      var legWrapHeight =
        $legWrap.text().trim().length && $legWrap.is(":visible")
          ? $legWrap.outerHeight()
          : 0;
      var toolbarElement = batchGeoToolbar.toolbarElement;
      toolbarElement.css("top", "initial");
      toolbarElement.css("bottom", legWrapHeight + 30);
    });

    batchGeoToolbar.hide();
    return batchGeoToolbar;
  };
})(window);
